/* eslint-disable no-console */

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  createStyles,
  Header,
  Group,
  Text,
  MediaQuery,
  Burger,
  Space,
  Button,
  Menu,
  Avatar,
  Tabs,
  Image,
  Title,
  Input,
  Modal,
  Center,
  Stack,
  PasswordInput,
} from '@mantine/core';
import { Users, Logout, Settings } from 'tabler-icons-react';
import { sendRequest } from '../services/services';
import Logo from '../image/spsLogoFinal.svg';

const useStyles = createStyles((theme) => ({
  links: {
    [theme.fn.smallerThan('md')]: {
      display: 'none',
    },
  },
  logo: {
    [theme.fn.smallerThan('md')]: {
      position: 'relative',
      bottom: 35,
    },
  },
}));

const TopNav = ({
  opened,
  setOpened,
  appState,
  menuList,
  paymentStatus,
  ticketId,
  totalSeconds,
}) => {
  const navigate = useNavigate();

  const { classes } = useStyles();
  const [, setGateData] = useState();
  const [collapsed, setCollapsed] = useState(false);
  const [configDetails, setConfigDetails] = useState({});

  // const gateIPAddress = configDetails?.gateIp;
  const comPortDetails = JSON.parse(localStorage.getItem('configDetails'));

  const gateFunction = () => {
    const body = {
      gate: 'out',
      cmd_type: '10',
      deviceId: configDetails?.deviceId,
      ip: configDetails?.ip,
      port: configDetails?.port,
    };

    sendRequest(`http://${comPortDetails?.gateIp}/command-manager`, 'post', body)
      .then(({ data, code }) => {
        if (code === 20) {
          setGateData(data);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          // console.log('err', err?.response?.data?.code);
        }
      });
  };

  const [passwordVerify, setPasswordVerify] = useState();
  const [isEdit, setIsEdit] = useState(false);

  const password = 'admin@cashier';
  const submitForm = () => {
    localStorage.setItem('configDetails', JSON.stringify(configDetails));
    window.location.reload();
  };

  useEffect(() => {
    const configDetailsData = localStorage.getItem('configDetails');
    if (configDetailsData) {
      setConfigDetails(JSON.parse(configDetailsData));
    }
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setConfigDetails((prevUserProfileData) => ({
      ...prevUserProfileData,
      [name]: value,
    }));
  };
  const getMenu = () => (
    <Group position="apart" spacing="xl" className={(classes.links, 'no-printme')}>
      <Tabs
        variant="pills"
        radius="xs"
        styles={(theme) => ({
          tab: {
            color: theme.black,
            backgroundColor: 'transparent',
            '&:hover': {
              color: theme.white,
              backgroundColor: theme.black,
            },
          },
        })}
        value={navigate.pathname}
        onTabChange={(value) => navigate(value)}
      >
        <Tabs.List>
          {[
            ...menuList.map((item) => {
              if (item !== null) {
                return (
                  <Tabs.Tab
                    key={`${item.path}-${item.label}`}
                    value={item.path}
                    {...(item.path === navigate.pathname
                      ? {
                          sx: (theme) => ({
                            color: `${theme.black} !important`,
                            backgroundColor: `${theme.white} !important`,
                          }),
                        }
                      : {})}
                  >
                    <Title order={6}>{item.label}</Title>
                  </Tabs.Tab>
                );
              }
              return item;
            }),
          ]}{' '}
        </Tabs.List>
      </Tabs>
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space w="md" />
      <Button
        onClick={gateFunction}
        disabled={
          paymentStatus === 'pending' && totalSeconds <= comPortDetails?.gracePeriod
            ? null
            : paymentStatus === 'pending' || ticketId === null
        }
      >
        Gate
      </Button>
      {!appState?.isAuthenticated ? (
        navigate('/')
      ) : (
        <Menu trigger="hover">
          <Menu.Target>
            {appState?.first_name ? (
              <Text>Cashier</Text>
            ) : (
              <Avatar radius="xl" size="sm" src="https://ui-avatars.com/api/" />
            )}
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Item icon={<Users size={20} />}>
              <Text>{appState?.first_name}</Text>
            </Menu.Item>
            <Menu.Item icon={<Settings size={20} />}>
              <Text onClick={() => setCollapsed(true)}>Settings</Text>
            </Menu.Item>
            <Menu.Item
              icon={<Logout size={20} />}
              onClick={() => {
                sendRequest(`/cashier/logout`, 'PATCH')
                  .then(({ msg }) => {
                    if (msg === 'Logout successfully!') {
                      console.log('err', msg);
                    }
                  })
                  .catch((err) => {
                    if (err?.response?.data?.code) {
                      console.log('err', err?.response?.data?.code);
                    }
                  });
                localStorage.setItem('token', '');
                localStorage.setItem('userData', '');
                navigate('/');
              }}
            >
              Logout
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      )}

      <Modal
        opened={collapsed}
        centered
        onClose={() => setCollapsed(false)}
        title={
          <Group>
            <Title order={6}>Configure</Title>
            {isEdit === false ? <Button onClick={() => setIsEdit(true)}>Edit</Button> : null}
          </Group>
        }
      >
        {isEdit ? (
          <Stack>
            <Stack>
              <Text>POS IPAddress</Text>
              <Input
                placeholder="Enter POS IP"
                label="POS IPAddress"
                withAsterisk
                required
                name="posIpAddress"
                value={configDetails.posIpAddress}
                onChange={handleInputChange}
              />
            </Stack>
            <Stack>
              <Text>Gate API IP Address</Text>
              <Input
                placeholder="Enter a gate IP Address"
                label="Gate IP Address"
                withAsterisk
                required
                name="gateIp"
                value={configDetails.gateIp}
                onChange={handleInputChange}
              />
            </Stack>
            <Stack>
              <Text>Device Id</Text>
              <Input
                placeholder="Enter a Device Id"
                label="Gate IP Address"
                withAsterisk
                required
                name="deviceId"
                value={configDetails.deviceId}
                onChange={handleInputChange}
              />
            </Stack>
            <Stack>
              <Text>Gate IP</Text>
              <Input
                placeholder="Enter a gate Gate IP"
                label="Gate IP Address"
                withAsterisk
                required
                name="ip"
                value={configDetails.ip}
                onChange={handleInputChange}
              />
            </Stack>
            <Stack>
              <Text>Gate IP Port</Text>
              <Input
                placeholder="Enter a gate IP Port"
                label="Gate Port"
                withAsterisk
                required
                name="port"
                value={configDetails.port}
                onChange={handleInputChange}
              />
            </Stack>
            <Stack>
              <Text>Grace Period</Text>
              <Input
                placeholder="Enter a GracePeriod (mins)"
                label="Grace Period"
                withAsterisk
                required
                name="gracePeriod"
                value={configDetails.gracePeriod}
                onChange={handleInputChange}
              />
            </Stack>
            <Stack>
              <PasswordInput
                placeholder="Enter Password"
                label="Password"
                withAsterisk
                value={passwordVerify}
                onChange={(e) => setPasswordVerify(e.target.value)}
              />
            </Stack>
          </Stack>
        ) : (
          <Stack>
            <Text>POS IPAddress</Text>
            <Input
              placeholder="Enter POS IpAddress"
              label="POS IPAddress"
              withAsterisk
              value={configDetails === null ? '' : configDetails.posIpAddress}
              disabled
            />
            <Text>Gate API IP Address</Text>
            <Input
              placeholder="Enter a gate IP Address"
              label="Com Port"
              withAsterisk
              value={configDetails === null ? '' : configDetails.gateIp}
              disabled
            />

            <Text>Device Id</Text>
            <Input
              placeholder="Enter Device Id"
              label="Com Port"
              withAsterisk
              value={configDetails === null ? '' : configDetails.deviceId}
              disabled
            />
            <Text>Gate IP</Text>
            <Input
              placeholder="Enter Gate IP"
              label="Com Port"
              withAsterisk
              value={configDetails === null ? '' : configDetails.ip}
              disabled
            />
            <Text>Gate IP Port</Text>
            <Input
              placeholder="Enter Gate IP Port"
              label="Com Port"
              withAsterisk
              value={configDetails === null ? '' : configDetails.port}
              disabled
            />
            <Text>Grace Period</Text>
            <Input
              placeholder="Enter a GracePeriod (mins)"
              label="Grace Period"
              withAsterisk
              required
              name="gracePeriod"
              value={configDetails === null ? '' : configDetails.gracePeriod}
              disabled
            />
          </Stack>
        )}
        <Center py="xl">
          <Group>
            {isEdit ? (
              <Button onClick={() => setIsEdit(false)} size="md">
                Cancel
              </Button>
            ) : null}
            {isEdit ? (
              <Button
                onClick={submitForm}
                disabled={password !== passwordVerify}
                size="md"
                color="blue"
              >
                Save
              </Button>
            ) : null}
          </Group>
        </Center>
      </Modal>
    </Group>
  );

  return (
    <Header
      className="no-printme"
      height={60}
      p="md"
      zIndex={40}
      fixed
      style={{
        height: '100%',
        backgroundColor: '#D9D9D9',
        zIndex: 20000,
        color: 'black',
      }}
    >
      <Group className="no-printme">
        <MediaQuery largerThan="md" styles={{ display: 'none' }}>
          <Burger
            opened={opened}
            onClick={() => setOpened((o) => !o)}
            size="md"
            color="#FFFFFF"
            mr="xl"
          />
        </MediaQuery>
        <Image
          src={Logo}
          onClick={() => navigate('/home')}
          width={80}
          style={{ marginTop: '-10px' }}
        />
        {getMenu()}
      </Group>
    </Header>
  );
};

export default TopNav;
